import { render, staticRenderFns } from "./ElderlySelect.vue?vue&type=template&id=613791f8&"
import script from "./ElderlySelect.vue?vue&type=script&lang=js&"
export * from "./ElderlySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports